import { createContext } from 'react';

import { NavMenuState } from './nav-menu.model';

export const NavMenuContext = createContext<NavMenuState | undefined>(undefined);

NavMenuContext.displayName = 'NavMenuContext';
